import { render, staticRenderFns } from "./other-form.html?vue&type=template&id=400c9556&scoped=true&external"
import script from "./other-form.js?vue&type=script&lang=js&external"
export * from "./other-form.js?vue&type=script&lang=js&external"
import style0 from "./other-form.scss?vue&type=style&index=0&id=400c9556&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400c9556",
  null
  
)

export default component.exports